function comparableText(value) {
  return String(value || "")
    .normalize("NFC")
    .replace(/[\u00a0\u200b]/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLocaleLowerCase();
}

function displayHeading(segment) {
  return segment?.display_heading || segment?.heading || segment?.locator || "";
}

/**
 * This is a presentation-only projection. It never mutates source blocks or
 * source text; it merely avoids rendering a first heading twice when the
 * reader already supplies that heading in its section summary.
 */
export function readerBlocks(segment) {
  const blocks = segment?.display_blocks || [];
  const heading = displayHeading(segment);
  if (!blocks.length || !heading) return blocks;

  const first = blocks[0];
  // A table's first cell is content, not a block heading.
  if (first?.type === "table") return blocks;
  const text = String(first?.text || "");
  const lines = text.split(/\r?\n/);
  const firstLine = lines.shift() || "";
  if (comparableText(firstLine) !== comparableText(heading)) return blocks;

  const remainder = lines.join("\n").trimStart();
  if (!remainder) return blocks.slice(1);
  return [{ ...first, text: remainder }, ...blocks.slice(1)];
}

/** Return rows only for a fully renderable structured table. */
export function tableRows(block) {
  if (block?.type !== "table" || !Array.isArray(block.rows) || !block.rows.length) return null;
  const valid = block.rows.every(
    (row) =>
      row &&
      Array.isArray(row.cells) &&
      row.cells.length > 0 &&
      row.cells.every(
        (cell) =>
          cell &&
          typeof cell.text === "string" &&
          (cell.header === undefined || typeof cell.header === "boolean"),
      ),
  );
  return valid ? block.rows : null;
}
